import { render, staticRenderFns } from "./TagChipComponent.vue?vue&type=template&id=1b1ac3aa&"
import script from "./TagChipComponent.vue?vue&type=script&lang=js&"
export * from "./TagChipComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports